import React from 'react';
import classes from './BannerImageAd.module.css';
import { Link } from 'react-router-dom';

const BannerImageAd = ({ image, className = '', link = '' }) => {
  // Ensure link starts with http(s) if it starts with "www"
  const formattedLink = link.startsWith('www') ? `https://${link}` : link;

  return (
    <Link
      to="/"
      {...(formattedLink && { to: formattedLink, target: '_blank', rel: 'noopener noreferrer' })}>
      <div className={[classes.main, className].join(' ')}>
        <img src={image} alt="" />
      </div>
    </Link>
  );
};

export default BannerImageAd;
